
export default function Services() {
  const services = [
    {
      number: '01',
      title: '自動化診断',
      items: [
        '現状の業務フローを可視化',
        '工数マップの作成',
        '自動化ロードマップの提案',
        '費用対効果の試算'
      ],
      duration: '目安：1週間'
    },
    {
      number: '02',
      title: '基盤構築',
      items: [
        'スプレッドシート設計',
        '利益計算ロジックの実装',
        '出品CSV生成の自動化',
        '在庫同期システムの構築'
      ],
      duration: '目安：2〜4週間'
    },
    {
      number: '03',
      title: '運用顧問',
      items: [
        '継続的な改善提案',
        '追加自動化の実装',
        '数値レビューとアドバイス',
        '運用サポート'
      ],
      duration: '月次契約'
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-b from-primary to-primary-light">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-white">
            3ステップで、運用を<strong>"OS化"</strong>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-5 md:p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-primary text-white rounded-full flex items-center justify-center text-xl md:text-2xl font-black mb-4 md:mb-6">
                {service.number}
              </div>
              
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">
                {service.title}
              </h3>
              
              <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 md:gap-3 text-gray-700">
                    <i className="ri-check-line text-primary text-lg md:text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-xs md:text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              
              <div className="pt-3 md:pt-4 border-t border-gray-200">
                <span className="text-xs md:text-sm text-gray-600">{service.duration}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
